import React from 'react';
import { Link } from 'react-router-dom';

const NutritionItem = props => {
  const { title, desc, LinkTo, enableDelete, deleteMeal, index } = props;

  return (
    <div className="nutrition-item">
      <i className="fas fa-carrot"></i>
      <div className="nutrition-info">
        <Link to={LinkTo}>{title}</Link>
        <p>{desc}</p>
      </div>
      {!!enableDelete && (
        <div className="ingredient-delete">
          <spam
            onClick={() => deleteMeal(index)}
            className="fas fa-trash trash-icon"
          ></spam>
        </div>
      )}
    </div>
  );
};

export default NutritionItem;
